<template>
  <page-article>
    <div class="col-12 page_content_area">
      <campus-recruiting-introduction
        :basic-info="currentCampusRecruitmentGetter"
      />
      <div class="col-12">
        <div class="row justify-content-center">
          <div class="col-12">
            <navigation
              :list="segments"
              :active-value="activeSegment"
              variety="segmented"
              @active:updated="updateActiveSegment"
            />
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12">
            <portlet class="campus_recruiting_content_area page_article_block">
              <keep-alive>
                <component :is="activeSegmentComponent" />
              </keep-alive>
            </portlet>
          </div>
        </div>
      </div>
    </div>
  </page-article>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Navigation from '~components/common/Navigation'
import pageArticle from '~components/pages/Article'
import Portlet from '~components/common/Portlet'
import CampusRecruitingIntroduction from '../common/CampusRecruitingIntroduction'
import EnterpriseSpecialIssue from '../nested/EnterpriseSpecialIssue'
import EnterpriseOrderDetails from '../nested/EnterpriseOrderDetails'
export default {
  name: 'CampusRecruitingDetails',
  components: {
    Navigation,
    pageArticle,
    Portlet,
    CampusRecruitingIntroduction,
    EnterpriseSpecialIssue,
    EnterpriseOrderDetails
  },
  data () {
    return {
      segments: ['活動專刊', '報名紀錄'],
      segmentComponents: [EnterpriseSpecialIssue, EnterpriseOrderDetails],
      activeSegment: '報名紀錄'
    }
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'currentCampusRecruitmentGetter',
      'currentEnterpriseGetter'
    ]),
    activeSegmentComponent () {
      return this.segmentComponents[this.segments.indexOf(this.activeSegment)]
    }
  },
  async created () {
    this.checkedRouterQuery()
    this.togglePageLoader(true)
    this.clearOrders()
	try {
		await this.getRecruitmentDetailsById(this.$route.params.id);
	}
	catch (err) {
		this.$router.push('/campus-recruiting');
	}
    if (Object.keys(this.currentEnterpriseGetter).length < 1) {
      await this.getEnterpriseByToken()
    }

    await this.checkedCampusRecruitmentId()
    this.togglePageLoader(false)
  },
  methods: {
    ...mapActions('pages/campus-recruiting', [
      'getRecruitmentDetailsById'
    ]),
    ...mapActions('pages/enterprises', [
      'getEnterpriseByToken',
      'getEnrolledCampusRecruitmentById',
      'clearOrders'
    ]),
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    checkedRouterQuery () {
      const specificSegment = this.$route.query.tab
      if (specificSegment) {
        this.updateActiveSegment(specificSegment)
      }
    },
    async checkedCampusRecruitmentId () {
      try {
        await this.getEnrolledCampusRecruitmentById(this.$route.params.id)
      } catch (err) {
        console.error(err)
        this.$router.replace({
          path: `/enterprises`,
          query: {
            tab: '活動專區'
          }
        })
      }
    },
    updateActiveSegment (segment) {
      if (this.$route.query.tab !== segment) {
        this.$router.push({
          query: {
            tab: segment
          }
        })
      }
      this.activeSegment = segment
    }
  }
}
</script>
